module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('user-warnings'), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Cronograma "), _c('v-chip', {
    attrs: {
      "outline": "",
      "color": "info"
    }
  }, [_vm._v("Público")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('exam-filters', {
    attrs: {
      "options": ['course', 'semester', 'enrolled'],
      "semester-required": true,
      "course-required": true,
      "can-select-any-course": true,
      "show-dev-semester": false
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  })], 1), _vm._v(" "), (_vm.activeMessages.length > 0) ? _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.activeMessages), function(message, idx) {
    return _c('v-alert', {
      key: 'message_' + idx,
      attrs: {
        "color": message.type,
        "value": "true",
        "dismissible": ""
      },
      model: {
        value: (message.show),
        callback: function($$v) {
          _vm.$set(message, "show", $$v)
        },
        expression: "message.show"
      }
    }, [_vm._v("\n                " + _vm._s(message.text) + "\n            ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "no-data-text": _vm.noDataCustom,
      "no-results-text": _vm.noResultCustom,
      "rows-per-page-text": _vm.rowsPerPageT,
      "expand": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item) ? _c('tr', [(_vm.isSmallScreen) ? _c('td', [_c('v-icon', [_vm._v("person")]), _vm._v(" Aluno:\n                    "), _c('ul', {
          staticClass: "no-padding"
        }, _vm._l((props.item.studentName), function(studentName, id) {
          return _c('ol', {
            key: id,
            staticClass: "no-padding studentName"
          }, [_vm._v("\n                            " + _vm._s(studentName) + "\n                        ")])
        }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("title")]), _vm._v(" \n                    Título: " + _vm._s(props.item.title) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("date_range")]), _vm._v(" Data: " + _vm._s(_vm._f("moment")(props.item.date, 'DD/MM/YYYY')) + " às " + _vm._s(props.item.hour) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("date_range")]), _vm._v(" Inscrição até: " + _vm._s(_vm.registrationBy(props.item)) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("edit_location")]), _vm._v(" Local: " + _vm._s(props.item.place) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("edit_location")]), _vm._v(" Vagas: " + _vm._s(props.item.vacancies) + " "), _c('br'), _vm._v(" "), (_vm.canEnroll(props.item) || props.item.enrolled) ? [(!_vm.authenticated || !props.item.enrolled) ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": !props.item.full ? 'success' : 'grey',
            "text-color": "white"
          }
        }, [_vm._v("\n                                " + _vm._s(!props.item.full ? "Inscrições abertas" : "Vagas esgotadas") + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.authenticated && props.item.enrolled && !props.item.present) ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": "green darken-1",
            "text-color": "white"
          }
        }, [_vm._v("\n                                Inscrito\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.authenticated && props.item.enrolled && props.item.present && !props.item.certification) ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n                                Presença confirmada\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.authenticated && props.item.enrolled && props.item.present && props.item.certification) ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": "primary",
            "text-color": "white"
          }
        }, [_vm._v("\n                                Presença certificada\n                            ")]) : _vm._e()] : [(!_vm.canEnroll(props.item)) ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": "grey darken-3",
            "text-color": "white"
          }
        }, [_vm._v("\n                                Inscrições encerradas\n                            ")]) : _vm._e()], _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', [_c('ul', {
          staticClass: "no-padding"
        }, _vm._l((props.item.studentName), function(studentName, id) {
          return _c('ol', {
            key: id,
            staticClass: "no-padding studentName"
          }, [_vm._v("\n                            " + _vm._s(studentName) + "\n                        ")])
        }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', [_c('table', [_c('div', [_c('v-card-text', {
          staticStyle: {
            "background-color": "none"
          }
        }, [_c('v-icon', [_vm._v("subject")]), _vm._v(" Título: " + _vm._s(props.item.title)), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("date_range")]), _vm._v(" Data: " + _vm._s(_vm._f("moment")(props.item.date, 'DD/MM/YYYY')) + " às " + _vm._s(props.item.hour) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("date_range")]), _vm._v(" Inscrição até: " + _vm._s(_vm.registrationBy(props.item)) + " "), _c('br'), _vm._v(" "), _c('v-icon', {
          attrs: {
            "title": _vm.authenticated ? props.item.registrations + ' inscritos' : ''
          }
        }, [_vm._v("edit_location")]), _vm._v(" Local: " + _vm._s(props.item.place) + " - "), _c('b', [_vm._v(_vm._s(props.item.vacancies) + " vagas ")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
          staticClass: "text-md-center"
        }, [(_vm.canEnroll(props.item) || props.item.enrolled) ? [(!_vm.authenticated || !props.item.enrolled) ? _c('v-chip', {
          attrs: {
            "color": !props.item.full ? 'success' : 'grey',
            "text-color": "white"
          }
        }, [_vm._v("\n                            " + _vm._s(!props.item.full ? "Inscrições abertas" : "Vagas esgotadas") + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.authenticated && props.item.enrolled && !props.item.present) ? _c('v-chip', {
          attrs: {
            "color": "green darken-1",
            "text-color": "white"
          }
        }, [_vm._v("\n                            Inscrito\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.authenticated && props.item.enrolled && props.item.present && !props.item.certification) ? _c('v-chip', {
          attrs: {
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n                            Presença confirmada\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.authenticated && props.item.enrolled && props.item.present && props.item.certification) ? _c('v-chip', {
          attrs: {
            "color": "primary",
            "text-color": "white"
          }
        }, [_vm._v("\n                            Presença certificada\n                        ")]) : _vm._e()] : [(!_vm.canEnroll(props.item)) ? _c('v-chip', {
          attrs: {
            "color": "grey darken-3",
            "text-color": "white"
          }
        }, [_vm._v("\n                            Inscrições encerradas\n                        ")]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), _c('td', [(_vm.authenticated) ? [(!props.item.full) ? [(_vm.canEnroll(props.item) && (!_vm.authenticated || !props.item.enrolled)) ? _c('v-btn', {
          attrs: {
            "color": "success",
            "floating": "",
            "small": "",
            "dark": "",
            "title": "Inscrever-se como ouvinte"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.checkTime(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "dark": "",
            "left": ""
          }
        }, [_vm._v("assignment_turned_in")]), _vm._v(" Inscrever-se\n                            ")], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.canEnroll(props.item) && (_vm.authenticated && props.item.enrolled && !props.item.present)) ? _c('v-btn', {
          attrs: {
            "color": "warning",
            "floating": "",
            "small": "",
            "dark": "",
            "title": "Cancelar inscrição como ouvinte"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamEnroll(props.item, false)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "dark": "",
            "left": ""
          }
        }, [_vm._v("assignment_late")]), _vm._v(" Cancelar inscrição\n                        ")], 1) : _vm._e()] : _vm._e()], 2)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('fullscreen-spinner'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.enrollDialog),
      callback: function($$v) {
        _vm.enrollDialog = $$v
      },
      expression: "enrollDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    class: _vm.enrollAction ? 'success' : 'warning',
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Confirma " + _vm._s(_vm.enrollAction === false ? 'o cancelamento d' : '') + "a sua inscrição na banca abaixo?")])], 1), _vm._v(" "), _c('exam-detail-list', {
    attrs: {
      "exam": _vm.selectedExam
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.enroll
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.enrollDialog = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.loginDialog),
      callback: function($$v) {
        _vm.loginDialog = $$v
      },
      expression: "loginDialog"
    }
  }, [_c('login', {
    attrs: {
      "redirect": false,
      "fullscreen": false
    },
    on: {
      "logged-in": _vm.closeLoginDialogAndFinishEnroll
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.loginDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21aa3e89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamSchedule.vue
// module id = 244
// module chunks = 0